import * as sdks from './sdks/index.ts';
export default (data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER'], extra: any = {}) => {
    Object?.keys(data)?.forEach(key => {
        if (sdks[key]) {
            sdks[key].entry(data[key], extra)
        }
    });
};

export const provider = {
    antiCybersource: sdks.cybersource.provideCybersourceDeviceId,
    antiForter: sdks.forter.provideForterDeviceId,
    antiForterSiteId: sdks.forter.provideForterSiteId,
    antiRiskified: sdks.riskified.provideRiskifiedDeviceId,
};